import Vue from "vue";
import axios from "axios";

function resolveHttpClient(httpClient) {
    const resolved = httpClient || Vue.prototype?.instance || axios.create();
    if (!resolved || typeof resolved.get !== "function") {
        return axios.create();
    }
    return resolved;
}

function resolveBaseUrl(apiBaseurl, httpClient) {
    const explicitBase = String(apiBaseurl || "").trim();
    if (explicitBase) {
        return explicitBase.replace(/\/$/, "");
    }
    const runtimeBase = String(httpClient?.defaults?.baseURL || "").trim();
    return runtimeBase.replace(/\/$/, "");
}

function buildManagerPath(apiBaseurl, path) {
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    const base = String(apiBaseurl || "").trim().replace(/\/$/, "");
    if (!base) {
        return normalizedPath;
    }
    if (/(^|\/)manager$/.test(base)) {
        return `${base}${normalizedPath}`;
    }
    return `${base}/manager${normalizedPath}`;
}

export function getSimilarImageReviewRecords(apiBaseurl = "", params = {}, httpClient) {
    const http = resolveHttpClient(httpClient);
    const resolvedBaseUrl = resolveBaseUrl(apiBaseurl, http);
    return http.get(buildManagerPath(resolvedBaseUrl, "/similar-image-review-records"), {
        params: {
            reviewStatus: params.reviewStatus || "pending",
            sourceCaseNo: params.sourceCaseNo || undefined,
            llmCategoryLevel1: params.llmCategoryLevel1 || undefined,
            similarityScoreMin: params.similarityScoreMin ?? undefined,
            similarityScoreMax: params.similarityScoreMax ?? undefined,
            similarityScoreOrder: params.similarityScoreOrder || undefined,
            pageNo: params.pageNo || 1,
            pageSize: params.pageSize || 20,
        },
    });
}

export function saveSimilarImageReviewDecision(apiBaseurl = "", reviewRecordId, payload = {}, httpClient) {
    if (!reviewRecordId) {
        throw new Error("reviewRecordId 不能为空");
    }
    if (!payload.decision) {
        throw new Error("payload.decision 必须提供");
    }
    const http = resolveHttpClient(httpClient);
    const resolvedBaseUrl = resolveBaseUrl(apiBaseurl, http);
    return http.post(
        buildManagerPath(
            resolvedBaseUrl,
            `/similar-image-review-records/${reviewRecordId}/decision`
        ),
        payload
    );
}

export function saveSimilarImageReviewBatchDecision(apiBaseurl = "", payload = {}, httpClient) {
    if (!Array.isArray(payload.reviewRecordIds) || !payload.reviewRecordIds.length) {
        throw new Error("payload.reviewRecordIds 必须提供");
    }
    if (!payload.decision) {
        throw new Error("payload.decision 必须提供");
    }
    const http = resolveHttpClient(httpClient);
    const resolvedBaseUrl = resolveBaseUrl(apiBaseurl, http);
    return http.post(
        buildManagerPath(
            resolvedBaseUrl,
            "/similar-image-review-records/batch-decision"
        ),
        payload
    );
}
